import React, {useEffect, useState} from 'react'
import {Button} from "antd";
import './style.css';
import ResultLabel from "./resultLabelComp";

export interface resultInterface {
    category?: any
}

const ScannerComp = () => {

    const [imgFile, setImgFile] = useState(new Blob())

    const [imgUrl, setImgUrl] = useState('');

    const [result, setResult] = useState<resultInterface>({})
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getResult();
    },[imgFile])

    const handleChange = (e: any) => {
        setLoading(true);
        setImgFile(e.target.files[0]);
        setImgUrl(URL.createObjectURL(e.target.files[0]));
    }

    const getResult = () => {
        const formData = new FormData()
        if (imgFile?.size !== 0) {
            formData?.append('image', imgFile);
            fetch('https://hexcamgua.onrender.com/predict', {
                method: 'POST',
                body: formData
            }).then(
                resp => {
                    console.log(resp)
                    resp.json().then(data => {
                        setResult(data)
                        setLoading(false)
                    });
                }
            );
        }
    }

    // const [files, setFiles] = useState<File[]>([])
    // Future feature: multiple files at once
    // useEffect(() => {
    //     getMultipleResults(files);
    // }, [files])
    //
    // const handleMultipleChange = (e) => {
    //     if (e.target.files && e.target.files.length) {
    //         setFiles(e.target.files);
    //     }
    // }
    //
    // const getMultipleResults = (files: File[]) => {
    //     files.forEach(f => {
    //         console.log(f)
    //     })
    // }

    return (
        <div>
            <h2 style={{fontSize: '30px'}}>Upload an X-Ray Chest Image for Results</h2>
            <Button id='inputLabel'>Upload Image</Button>
            <input type="file" name="file" id="file" onChange={handleChange}/>
            <img src={imgUrl} style={{height: '300px'}} />
            <ResultLabel result={result} loading={loading}/>
        </div>
    )
}

export default ScannerComp
